module.exports = __webpack_public_path__ + "img/m.093ed8fa.jpg";